<div>
    <label aviLabelWithTooltip>
        {{ l10nKeys.serviceUnitsUsageHeader  | vtranslate }}
    </label>
</div>
<div class="chart-container"></div>
<div class="tooltip-container"></div>
